/*!
 * Copyright (c) Microsoft. All rights reserved.
 * Licensed under the MIT license. See LICENSE file in the project.
 */

import styled from 'styled-components'

export const ChartOptionsGroupWrapper = styled.div`
	display: flex;
	gap: 0.5rem;
	flex-direction: column;
`
